import styled from 'styled-components';
import { spacing, base } from '@alinta-digital/asg';
import { addBreakpoint } from '@alinta-digital/asg';

const LinkSection = styled.div`
  margin-top: 8px;
  ${addBreakpoint(
    base.global.breakpoints.xs,
    `padding: ${spacing().xsmall} 0;`,
    'up'
  )};
  ${addBreakpoint(
    base.global.breakpoints.sm,
    `padding: ${spacing(32).xlarge} 0;`,
    'up'
  )};
`;

export default LinkSection;
